import { ListItem } from "../models/ListItem";
import GenericService from "./genericService";
import { httpService } from "./httpService";
import { Facility } from "../models/facility.model";
import { PagedResultDTO, PaginatedRequest } from "../models/pagedResultDto.model";

class FacilityService extends GenericService<Facility, ListItem> {
    constructor() {
        super('/api/Facility');
    }

    async getByPropertyId(propertyId: number): Promise<Facility[]> {
        return await httpService.get<Facility[]>(`/api/Facility/GetByPropertyId?Id=${propertyId}`, undefined, {
            unwrap: true,
            normalize: true,
            toast: false,
        });
    }

    async getFacilitiesByRoomId(roomId: number | string): Promise<Facility[]> {
        return await httpService.get<Facility[]>(`/api/Facility/GetFacilitiesByRoomId/${roomId}`, undefined, {
            unwrap: true,
            normalize: true,
            toast: false,
        });
    }
     async getAllFacilities(pageNumber: number, pageSize: number): Promise<PagedResultDTO<Facility[]>> {
        return await httpService.get<PagedResultDTO<Facility[]>>(
            `/api/Facility/GetAllFacility/${pageNumber}/${pageSize}`,
            undefined,
            {
                unwrap: true,
                normalize: true,
                toast: false,
            }
        );
    }
}

export const facilityService = new FacilityService();